import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Button, Card, CardBody, CardHeader, Center, Container, FormControl, Grid, Heading, Stack } from '@chakra-ui/react';
import { Input } from '@chakra-ui/react'
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validateUser } from '../../redux/features/authSlice';
import { AppDispatch } from '../../redux/storage';
import LoadingPage from '../../pages/LoadingPage';
import Alerts from '../../components/ui/Alerts';
import { useNavigate } from 'react-router-dom';
import PasswordInput from '../../components/ui/PasswordInput';
import usePageTitle from '../../utils/pageTitle';

function Login() {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>();
    const credentials = useSelector((user: any) => user.credentials)

    usePageTitle("Inicio sesión")

    const handleLoginForm = (event: any) => {

        event.preventDefault()

        dispatch(validateUser({ email, password }))
    }

    return (
        <Grid minHeight="100vh">
            <Center>
                <Container>
                    {credentials.loading && <LoadingPage />}
                    {credentials.error !== '' && <Alerts message={credentials.error} title='Error' />}
                    {!credentials.loading &&
                        <Card>
                            <CardHeader>
                                <Heading size='md'>
                                    <Center>
                                        Inicio de sesión
                                    </Center>
                                </Heading>
                            </CardHeader>
                            <CardBody>
                                <Stack spacing={3}>
                                    <form onSubmit={handleLoginForm}>
                                        <FormControl>
                                            <Input placeholder='Correo' value={email} onChange={(e) => setEmail(e.target.value)} />
                                            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} />
                                            <Button width='100%' rightIcon={<ArrowForwardIcon />} colorScheme='brand' variant='solid' type='submit' mt={5}>Ingresar</Button>
                                        </FormControl>
                                    </form>
                                </Stack>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </Center>
        </Grid>
    );
}

export default Login;
